import React, { useState } from "react";
import { Modal, Radio, Input, message } from "antd";

const REPORT_REASONS = [
  "Spam or advertising",
  "Harassment or bullying",
  "Misinformation or false content",
  "Hate speech or discrimination",
  "Explicit or NSFW content",
  "Other",
];

const ReportModal = ({
  open,
  onClose,
  onSubmit, // (payload) => void
  title = "Report Post",
}) => {
  const [reason, setReason] = useState(null);
  const [otherText, setOtherText] = useState("");

  const handleOk = () => {
    if (!reason) {
      message.error("Please select a reason to proceed.");
      return;
    }
    // if (reason === "Other" && !otherText.trim()) {
    //   message.error("Please provide details for 'Other'.");
    //   return;
    // }

    const payload = {
      reason,
      details: reason === "Other" ? otherText.trim() : "",
    };

    onSubmit?.(payload);
    // reset after submit
    setReason(null);
    setOtherText("");
    onClose?.();
  };

  const handleCancel = () => {
    setReason(null);
    setOtherText("");
    onClose?.();
  };

  return (
    <Modal
      open={open}
      onCancel={handleCancel}
      footer={null}
      centered
      width={660}
      className="report-modal"
      closeIcon={<span className="report-close">×</span>}
    >
      <div className="report-modal-content">
        <h4 className="report-title">{title}</h4>
        <p className="report-subtitle">Select a reason for reporting this post:</p>

 <Radio.Group
  onChange={(e) => setReason(e.target.value)}
  value={reason}
  className="report-radio-group"
>
  <div className="report-options">
    {REPORT_REASONS.map((item) => (
      <Radio
        key={item}
        value={item}
        className="report-option"
        style={{ color: "white" }}
      >
        {item}
      </Radio>
    ))}
  </div>
</Radio.Group>

        {/* {reason === "Other" && (
          <Input.TextArea
            rows={4}
            placeholder="Please describe the issue..."
            value={otherText}
            onChange={(e) => setOtherText(e.target.value)}
            className="report-textarea"
          />
        )} */}

        <button className="report-submit-btn" onClick={handleOk}>
          Submit Report
        </button>
      </div>
    </Modal>
  );
};

export default ReportModal;
